export default "__VITE_ASSET__C0adQtab__"